import {ErrorSmall} from '@wix/wix-ui-icons-common/on-stage'
import classNames from 'classnames'
import React, {useEffect, useRef} from 'react'
import s from '../../fields.scss'
import {ErrorProps} from './interfaces'

export const Error = ({dataHook, className, error}: ErrorProps) => {
  const errorRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (error && errorRef.current) {
      // Adding setTimeout because there was a form issue on ios device with some languages (IME)
      setTimeout(() => {
        errorRef.current.focus()
      }, 0)
    }
  }, [error])

  return error ? (
    <div
      ref={errorRef}
      data-hook={dataHook}
      className={classNames(s.error, className)}
      role="alert"
      aria-live="assertive"
      tabIndex={-1}
    >
      <ErrorSmall className={s.icon} aria-hidden />
      {error}
    </div>
  ) : null
}
